import { Button, Heading, Text } from '@makemydeal/dr-ui-bricks-components';

import type { TradeInOverviewInfoProps } from '../../types/TradeInOverviewTypes';
import {
    TradeInOverviewActions,
    TradeInOverviewField,
    TradeInOverviewFields,
    TradeInOverviewInfoRoot,
    TradeInOverviewVehicle
} from './TradeInOverview.style';
import { TRADE_IN_RECORD_CONTENT } from '../../constants';

export const TradeInOverviewInfo = ({ tradeIn, onEdit, onRemove }: TradeInOverviewInfoProps) => {
    return (
        <TradeInOverviewInfoRoot data-testid="trade-in-record">
            <TradeInOverviewFields>
                <TradeInOverviewVehicle>
                    <Heading as="h3" level={6} weight="semibold">
                        Vehicle
                    </Heading>
                    <Text size="base" color={tradeIn.valueColor} data-testid="trade-in-record-vehicle">
                        {tradeIn.data?.vehicleName || tradeIn.emptyValue}
                    </Text>
                </TradeInOverviewVehicle>
                {tradeIn.fields.map(({ label, value, color, testId }) => (
                    <TradeInOverviewField key={testId}>
                        <Heading as="h3" level={6} weight="semibold">
                            {label}
                        </Heading>
                        <Text size="base" color={color} data-testid={testId}>
                            {value}
                        </Text>
                    </TradeInOverviewField>
                ))}
            </TradeInOverviewFields>
            <TradeInOverviewActions>
                <Button data-testid="trade-in-record-remove" buttonStyle="secondary" onClick={onRemove}>
                    {TRADE_IN_RECORD_CONTENT.removeLabel}
                </Button>
                <Button data-testid="trade-in-record-edit" buttonStyle="secondary" onClick={onEdit}>
                    {TRADE_IN_RECORD_CONTENT.editLabel}
                </Button>
            </TradeInOverviewActions>
        </TradeInOverviewInfoRoot>
    );
};
